import React from 'react'

function Contact() {
    return (
<div className='contact text-center text-3xl text-gray-600 pt-40 font-bold leading-10'> 

      Mail me @ <a href='mailto:tenkus47@gmail.com' className='text-blue-400 cursor-pointer underline '>tenkus47@gmail.com</a>
       <br/>
      Whatsapp me @ <a href='https://wa.me/8744948878' className='text-blue-400 cursor-pointer underline'>8744948878</a>
     <br/>
      Location: Dharamsala , India
</div>
       
    )
}

export default Contact
